import axios from 'axios'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const Verifi = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const verify = async (e)=>{
        e.preventDefault()
        // console.log(location.state)
        const fdata = new FormData(e.currentTarget)
        const adata = {
            otp:fdata.get("otp"),
            name:location.state.name,
            email:location.state.email,
            password:location.state.password
        }
        // console.log(adata)
        if(fdata.get("otp")===location.state.otp){
            const r = await axios.post(`https://whatsappbac.vercel.app/registerverifi/`, adata)
            // console.log("done", adata)
            navigate("/")
        }
        else{
            alert("wrong")
            return
        }
    }
  return (
    <>
    <div className='container'>
        <div>
        <h1 style={{backgroundColor:"red", color:"white", padding:"5px"}}>Chit-Chat</h1>
        <div>
            <form onSubmit={verify}>
                <input type="text" name="otp" placeholder='OTP' required />
                <button className='btn btn-danger' type="submit">Verify</button>
            </form>
        </div>
        </div>
    </div>
    </>
  )
}

export default Verifi